import React from "react";
import { FiBookOpen, FiCheckCircle } from "react-icons/fi";
import { formatSchedule } from "./StudentClassSchedule";

const getName = (value, fallback = "Lớp học") => {
  if (!value) return fallback;
  if (typeof value === "string") return value;
  if (typeof value === "object") return value.vi || value.en || fallback;
  return String(value);
};

export default function StudentClassSidebar({ classes = [], selectedClassId, onSelect, assignmentCounts = {} }) {
  return (
    <aside className="rounded-2xl border bg-white p-3 shadow-sm">
      <div className="px-2 py-2 font-bold text-slate-900 flex items-center gap-2">
        <FiBookOpen /> Lớp của tôi
      </div>

      <div className="space-y-2 mt-2">
        <button
          type="button"
          onClick={() => onSelect("all")}
          className={`w-full text-left rounded-xl p-3 border transition ${
            selectedClassId === "all" ? "bg-blue-600 text-white border-blue-600" : "bg-white hover:bg-slate-50"
          }`}
        >
          <div className="font-semibold flex items-center justify-between">
            Tất cả lớp
            {selectedClassId === "all" && <FiCheckCircle />}
          </div>
          <div className={`text-xs mt-1 ${selectedClassId === "all" ? "text-blue-50" : "text-slate-500"}`}>
            {assignmentCounts.all || 0} bài tập/kiểm tra
          </div>
        </button>

        {classes.map((cls) => (
          <button
            type="button"
            key={cls.id}
            onClick={() => onSelect(cls.id)}
            className={`w-full text-left rounded-xl p-3 border transition ${
              selectedClassId === cls.id ? "bg-blue-600 text-white border-blue-600" : "bg-white hover:bg-slate-50"
            }`}
          >
            <div className="font-semibold flex items-center justify-between gap-2">
              <span className="line-clamp-1">{getName(cls.name)}</span>
              {selectedClassId === cls.id && <FiCheckCircle className="shrink-0" />}
            </div>
            <div className={`text-xs mt-1 line-clamp-2 ${selectedClassId === cls.id ? "text-blue-50" : "text-slate-500"}`}>
              {formatSchedule(cls.schedule)}
            </div>
            <div className={`text-xs mt-2 ${selectedClassId === cls.id ? "text-blue-50" : "text-slate-500"}`}>
              {assignmentCounts[cls.id] || 0} bài tập/kiểm tra
            </div>
          </button>
        ))}
      </div>
    </aside>
  );
}
